import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"line-height":"60px","text-align":"center","background":"rgb(119 85 85)","color":"black"} }
const _hoisted_2 = { style: {"position":"absolute"} }
const _hoisted_3 = { style: {"text-align":"right","margin-right":"10"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lay_icon = _resolveComponent("lay-icon")!
  const _component_lay_menu_item = _resolveComponent("lay-menu-item")!
  const _component_lay_sub_menu = _resolveComponent("lay-sub-menu")!
  const _component_lay_menu = _resolveComponent("lay-menu")!
  const _component_lay_side = _resolveComponent("lay-side")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_dropdown_menu_item = _resolveComponent("lay-dropdown-menu-item")!
  const _component_lay_dropdown_menu = _resolveComponent("lay-dropdown-menu")!
  const _component_lay_dropdown = _resolveComponent("lay-dropdown")!
  const _component_lay_header = _resolveComponent("lay-header")!
  const _component_chartView = _resolveComponent("chartView")!
  const _component_loufengListView = _resolveComponent("loufengListView")!
  const _component_loufengProcessView = _resolveComponent("loufengProcessView")!
  const _component_payDetailsView = _resolveComponent("payDetailsView")!
  const _component_payConfigView = _resolveComponent("payConfigView")!
  const _component_userListView = _resolveComponent("userListView")!
  const _component_adminUserLustView = _resolveComponent("adminUserLustView")!
  const _component_setupView = _resolveComponent("setupView")!
  const _component_complaint = _resolveComponent("complaint")!
  const _component_domainName = _resolveComponent("domainName")!
  const _component_changePasswordView = _resolveComponent("changePasswordView")!
  const _component_opinion = _resolveComponent("opinion")!
  const _component_lay_body = _resolveComponent("lay-body")!
  const _component_lay_layout = _resolveComponent("lay-layout")!

  return (_openBlock(), _createBlock(_component_lay_layout, { class: "example" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_side, { style: {"width":"auto","flex":"0 0 auto","align-items":"normal"} }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_menu, {
            "selected-key": $setup.selectedKey,
            "onUpdate:selectedKey": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedKey) = $event)),
            tree: $setup.isTree,
            "onUpdate:tree": _cache[1] || (_cache[1] = ($event: any) => (($setup.isTree) = $event)),
            "open-keys": $setup.openKeys6,
            "onUpdate:openKeys": _cache[2] || (_cache[2] = ($event: any) => (($setup.openKeys6) = $event)),
            onChangeSelectedKey: $setup.changeSelectedKey,
            collapse: $setup.collapse,
            style: {"padding-top":"0px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString($setup.userName), 1),
              _createVNode(_component_lay_menu_item, { id: "1" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-chart" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 首页 ")
                ]),
                _: 1
              }),
              _createVNode(_component_lay_sub_menu, { id: "2" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-read" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 楼凤 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_lay_menu_item, { id: "3" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" 楼凤列表")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_menu_item, { id: "4" }, {
                    title: _withCtx(() => [
                      _createTextVNode("审核管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_sub_menu, { id: "5" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-dollar" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 财务 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_lay_menu_item, { id: "6" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" 明细列表")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_menu_item, { id: "7" }, {
                    title: _withCtx(() => [
                      _createTextVNode("支付配置")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_sub_menu, { id: "8" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-user" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 用户 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_lay_menu_item, { id: "9" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" 用户列表")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_menu_item, { id: "10" }, {
                    title: _withCtx(() => [
                      _createTextVNode("后台用户")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_sub_menu, { id: "15" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-question" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 信息管理 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_lay_menu_item, { id: "14" }, {
                    title: _withCtx(() => [
                      _createTextVNode("投诉列表")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_menu_item, { id: "16" }, {
                    title: _withCtx(() => [
                      _createTextVNode("建议意见")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_sub_menu, { id: "11" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_lay_icon, { type: "layui-icon-set-sm" })
                ]),
                title: _withCtx(() => [
                  _createTextVNode(" 系统 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_lay_menu_item, { id: "12" }, {
                    title: _withCtx(() => [
                      _createTextVNode("系统设置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_menu_item, { id: "13" }, {
                    title: _withCtx(() => [
                      _createTextVNode("域名管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selected-key", "tree", "open-keys", "onChangeSelectedKey", "collapse"])
        ]),
        _: 1
      }),
      _createVNode(_component_lay_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_lay_header, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_lay_icon, {
                  type: $setup.collapse ? 'layui-icon-spread-left' : 'layui-icon-shrink-right',
                  size: "lg",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.menuSize($setup.collapse)))
                }, null, 8, ["type"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_lay_dropdown, {
                  trigger: "hover",
                  updateAtScroll: ""
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_lay_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.changePassword }, {
                          default: _withCtx(() => [
                            _createTextVNode("修改密码")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.quit }, {
                          default: _withCtx(() => [
                            _createTextVNode("退出")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_lay_button, { style: {"border-color":"transparent"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.userName) + " ", 1),
                        _createVNode(_component_lay_icon, {
                          type: "layui-icon-down",
                          style: {"margin-right":"10"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_body, null, {
            default: _withCtx(() => [
              ($setup.viewsType == 1)
                ? (_openBlock(), _createBlock(_component_chartView, { key: 0 }))
                : ($setup.viewsType == 3)
                  ? (_openBlock(), _createBlock(_component_loufengListView, { key: 1 }))
                  : ($setup.viewsType == 4)
                    ? (_openBlock(), _createBlock(_component_loufengProcessView, { key: 2 }))
                    : ($setup.viewsType == 6)
                      ? (_openBlock(), _createBlock(_component_payDetailsView, { key: 3 }))
                      : ($setup.viewsType == 7)
                        ? (_openBlock(), _createBlock(_component_payConfigView, { key: 4 }))
                        : ($setup.viewsType == 9)
                          ? (_openBlock(), _createBlock(_component_userListView, { key: 5 }))
                          : ($setup.viewsType == 10)
                            ? (_openBlock(), _createBlock(_component_adminUserLustView, { key: 6 }))
                            : ($setup.viewsType == 12)
                              ? (_openBlock(), _createBlock(_component_setupView, { key: 7 }))
                              : ($setup.viewsType == 14)
                                ? (_openBlock(), _createBlock(_component_complaint, { key: 8 }))
                                : ($setup.viewsType == 13)
                                  ? (_openBlock(), _createBlock(_component_domainName, { key: 9 }))
                                  : ($setup.viewsType == 0)
                                    ? (_openBlock(), _createBlock(_component_changePasswordView, { key: 10 }))
                                    : ($setup.viewsType == 16)
                                      ? (_openBlock(), _createBlock(_component_opinion, { key: 11 }))
                                      : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}